module.exports = __webpack_public_path__ + "static/media/update.d41d8cd9.bin";